import React, { Fragment, useContext, useEffect, useState } from 'react';
import {
	darkTheme,
	GlobalStyles,
	lightTheme,
} from '../../../utils/themes/theme';

import { useDarkMode } from '../../../hooks/useDarkMode';
import { ThemeProvider } from 'styled-components';
import './style/index.css';
// import ravenLoader from '../../../assets/images/raven-loader.gif';
import HeaderNavComponent from '../headerNav';
import SideMenuComponent from '../sideMenu';
import GetUser from '../../../components/common/getUser/index';
// import { RavenActionBar } from '@ravenpay/raven-bank-ui';
import RootState, { ActivateBankBoxPayload } from '../../../redux/types';
import { useDispatch, useSelector } from 'react-redux';
// import { logger } from '../../../services/logger';
import { useNavigate } from 'react-router-dom';
import { toggleMenu } from '../../../redux/actions/actions';
// import { getCookie } from '../../../utils/helper/Helper';
import SessionEndModal from './SessionExpired';
import { bankboxAPI } from '../../../redux/bankbox';
import ActionContext from '../../../context/ActionContext';
import ConfirmLogoutModal from '../ConfirmLogoutModal';
import { getCookie, mapHotkey, setCookie } from '../../../utils/helper/Helper';
import UseUser from '../../../hooks/useUser';
import NoContentBox from '../../../pages/dashboard/bankbox/components/no-content/NoContentBox';
import EmptyBankBoxOverview from '../../../pages/dashboard/bankbox/components/overview/EmptyOverview';
import SetupBankbox from '../../../pages/dashboard/bankbox/components/modals/SetupBankbox';
import { RavenModal } from '@ravenpay/raven-bank-ui';

interface MyComponentProps {
	children?: React.ReactNode;
	loading?: boolean;
	back?: boolean;
	onBack?: () => void;
	actionBarComp?: React.ReactNode;
}

type ToastType = 'none' | 'warning' | 'info' | 'error' | undefined;

const DashboardLayout: React.FC<MyComponentProps> = ({
	children,
	loading,
	back,
	onBack,
	actionBarComp,
}: MyComponentProps) => {
	const { isMenuOpen } = useSelector((state: RootState) => state.general);
	const { profile, loading_profile_info } = useSelector(
		(state: RootState) => state.settings
	);
	const { partner_info, banks, loading_Partner_info } = useSelector(
		(state: RootState) => state.bankbox
	);
	const [theme, toggleTheme] = useDarkMode(localStorage.getItem('theme'));
	const themeMode = theme === 'light' ? lightTheme : darkTheme;
	const toks = getCookie('token');
	const { bvn, verified } = profile?.merchantInfo ?? { bvn: 0, verified: 0 };

	const { address_status } = profile?.businessInfo ?? {
		address_status: 0,
		document_verification_status: 0,
		cac_verified: 0,
		registration_number: null,
		transaction_range: null,
		industry: null,
		business_address: null,
	};
	const formInitialState = {
		merchant_email: profile?.businessInfo?.business_email,
		fname: '',
		lname: '',
		bvn: '',
		nin: '',
		webhook_url: '',
		app_name: '',
		brand_color_code: '#0B8376',
		device_price: '',
		cap_fee_percentage: '',
		cap_amount: '',
		website: '',
		phone: '',
		suppport_email: '',
		webhook_secret: '',
		operating_region: '',
		address: '',
	};
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const showToast = bvn !== 3 || verified !== 1 || address_status !== 1;
	// logger.log(showToast, 'profile');
	const [showBar, setShowBar] = React.useState(showToast);

	useEffect(() => {
		// //(partner_info?.partner_info?.status);

		if (Object?.keys(partner_info)?.length < 1) {
			dispatch(bankboxAPI.getBankboxPartner({} as any) as any);
		}
		const statusVal = partner_info?.partner_info?.status;
		if (
			banks?.length < 1 &&
			String(statusVal && Object?.keys(partner_info)?.length > 0) === '1'
		) {
			dispatch(bankboxAPI.getBankboxBanks({}));
		}
	}, []);

	const bankbox_token = getCookie('x-pos-key') as string;
	const actionCtx = useContext(ActionContext);

	useEffect(() => {
		const statusVal = partner_info?.partner_info?.status;

		// if (profile?.merchantInfo?.bankbox_key) {
		if (bankbox_token && String(statusVal) === '1') {
			// setCheck(true);
			// //("----nbdg-----");
			// setCookie('x-pos-key', profile?.merchantInfo?.bankbox_key, 3000);

			actionCtx.setIsProfileCheck(true);
		} else {
			// setCheck(false);
			actionCtx.setIsProfileCheck(false);
		}

		if (Object?.keys(profile)?.length > 0) {
			setActivateFormData({
				...activateFormData,
				merchant_email: profile?.businessInfo?.business_email,
			});
			if (
				localStorage?.getItem('theme-color') === null ||
				localStorage?.getItem('theme-color') === '' ||
				localStorage?.getItem('theme-color') === undefined
			) {
				if (!profile?.partnerDetails?.color_code) {
					const color = `#${profile?.partnerDetails?.color_code}`;
					actionCtx?.setThemeColor(color);
				} else {
					const color = '#014345';
					actionCtx?.setThemeColor(color);
				}
			} else {
				const color =
					`#${profile?.partnerDetails?.color_code || '014345'}` ||
					'var(--primary-base-color)';
				actionCtx?.setThemeColor(color);
			}
		}
	}, [profile]);

	// setThemeColor -----------

	const [empty, setEmpty] = React.useState<boolean>(true);
	const [activateFormData, setActivateFormData] =
		useState<ActivateBankBoxPayload>(formInitialState);
	const [setupModal, setSetupModal] = React.useState<boolean>(false);

	const handleChange = (e: any) => {
		const { name, value } = e.target;
		const obj = { ...activateFormData, [name]: value };
		setActivateFormData(obj);
	};

	const [step, setStep] = React.useState<{
		id: string;
		completed: string[];
		label: string;
	}>({
		id: 'basic',
		completed: [],
		label: 'Basic Details',
	});

	React.useEffect(() => {
		mapHotkey('m', () => setEmpty(!empty));
	}, [empty]);

	const appid = getCookie('x-pos-key');
	const [check, setCheck] = useState(false);
	React.useEffect(() => {
		if (!getCookie('x-pos-key')) {
			if (appid) {
				setCookie('x-pos-key', appid, 3000);
			}
		}
	}, [appid]);

	return (
		<Fragment>
			{/* {Object?.keys(profile)?.length < 1 ? (
				<></>
			) : ( */}
			<ThemeProvider theme={themeMode}>
				<GlobalStyles />
				{toks && <UseUser />}
				{loading_profile_info && Object?.keys(profile)?.length < 1 ? (
					<>
						<div
							className="white-base-black-bg"
							style={{ height: '100vh', width: '100vw' }}
						>
							<NoContentBox loading={true} />
						</div>
					</>
				) : (
					<>
						{' '}
						<div className="dashboard-layout-wrap">
							{/* sidenav wrap start */}

							<div
								className={`side-nav-wrap ${
									actionCtx?.collapseNav ? 'side-nav-wrap-collapse' : ''
								}`}
							>
								<SideMenuComponent theme={theme} />
							</div>

							{/* sidenav wrap end */}
							{/* main body wrap start */}
							<div
								// onClick={() => {
								// 	//(actionCtx?.themeColor);
								// }}
								className={`main-body-wrap  ${
									actionCtx?.collapseNav ? 'main-body-wrap-collapse' : ''
								}`}
							>
								{/* header wrap start */}

								<div
									className={`header-wrap white-base-black-bg ${
										location.pathname.includes('dashboard-onboarding-') &&
										'onboarding-header'
									}`}
								>
									<HeaderNavComponent
										onBack={onBack}
										back={back}
										theme={theme}
										toggleTheme={toggleTheme as any}
									/>
								</div>
								{/* ActionBar start */}
								{actionBarComp ? <>{actionBarComp}</> : ''}
								{/* ActionBar end */}

								{/* header wrap end */}
								{/* main wrap start */}

								<div className="main-wrap main-wrap-bg">
									{!actionCtx?.isProfileCheck &&
									!profile?.merchantInfo?.bankbox_key ? (
										<EmptyBankBoxOverview onClick={() => setSetupModal(true)} />
									) : (
										children
									)}
								</div>
								{/* main wrap end */}
							</div>
							{/* main body wrap end */}
						</div>
					</>
				)}
				<RavenModal
					visble={setupModal && !profile?.merchantInfo?.bankbox_key}
					// visble={true}
					onClose={() => {
						setSetupModal(false);
						setStep({ id: 'basic', completed: [], label: 'Basic Details' });
						setActivateFormData(formInitialState);
					}}
					className={'bankbox-create-modal bankbox-create-setup-modal'}
					onBtnClick={function (e?: any): void {
						throw new Error('Function not implemented.');
					}}
				>
					<SetupBankbox
						onComplete={() => {
							setSetupModal(false);
							setStep({ id: 'basic', completed: [], label: 'Basic Details' });
						}}
						onChange={handleChange}
						setBrandColor={function (e: any) {
							setActivateFormData({
								...activateFormData,
								brand_color_code: e,
							});
						}}
						setStep={function (e: {
							id: string;
							completed: string[];
							label: string;
						}): void {
							setStep(e);
						}}
						step={step}
						formData={activateFormData}
					/>
				</RavenModal>
				<ConfirmLogoutModal />
				<SessionEndModal />
			</ThemeProvider>
			{/* )} */}
		</Fragment>
	);
};

export default DashboardLayout;
